import {
  PermissionAction,
  PermissionScope,
  PermissionTableDataType,
} from 'dashboard/components/PermissionsTable/constants';
import { Permission } from 'lib/permissions';

export const DataSectionData: PermissionTableDataType = {
  sections: [
    {
      label: 'View full 9-digit SSN',
      tooltip: 'Allows this role to see the full 9-digit SSN instead of the last 4 digits',
      subSections: [
        {
          scopes: [PermissionScope.Environment],
          rows: [
            {
              label: 'Inquiries',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.InquirySsnView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Verifications',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.VerificationDatabaseSsnView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Accounts',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.AccountSsnView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Reports',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.ReportSsnView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'View ID numbers',
      tooltip:
        'Allows this role to see ID numbers of various kinds, including from documents submitted by individuals',
      subSections: [
        {
          scopes: [PermissionScope.Environment],
          rows: [
            {
              label: 'Inquiries',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.InquiryGovIdNumberView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Verifications',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.VerificationGovIdNumberView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
            {
              label: 'Accounts',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.AccountIdNumbersView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      label: 'View verification normalized files',
      tooltip: 'Allows this role to see normalized verification images',
      subSections: [
        {
          scopes: [PermissionScope.Environment],
          rows: [
            {
              label: 'Verifications',
              actions: [
                {
                  label: PermissionAction.View,
                  permissions: [
                    {
                      permission: Permission.DashboardVerificationsNormalizedView,
                      scopes: [PermissionScope.Environment],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
